import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref, watch } from 'vue';
import { Tag } from '@/interfaces/model/general/tag';
import { useTagComposable } from '@/composables/useTag';
import TagChip from '@/components/TagChip.vue';
import VSelect from 'vuetify/lib/components/VSelect/VSelect';
import { defineMessages } from '@/lib/i18n';
import sharedMessages from '@/lib/shared-messages';
import { i18n } from '@/plugins/vue-i18n';
import { NO_TAG_ID } from '@/lib/constant';

interface CustomTag extends Tag {
  selected?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SelectTags',
  props: {
    selectedTagIds: null,
    isNoTagSelected: { type: Boolean },
    noDataText: null,
    isReturnTagObject: { type: Boolean },
    isHideTitle: { type: Boolean }
  },
  emits: ["updateTags", "updateIncludeNoTag"],
  setup(__props: any, { emit: emits }: { emit: ({
  <T extends boolean>(
    e: 'updateTags',
    tagId: T extends true ? Tag[] : number[]
  ): void;
  (e: 'updateIncludeNoTag', value: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  selectedTagIds?: number[];
  isNoTagSelected?: boolean;
  noDataText?: string;
  isReturnTagObject?: boolean;
  isHideTitle?: boolean;
};

const $t = i18n.t.bind(i18n);

const m = defineMessages({
  noDataFound: 'タグが見つかりませんでした。',
});





const isLoading = ref<boolean>(true);
const defaultTags = ref<CustomTag[]>([]);
const selectedTags = ref<CustomTag[]>([]);
const searchKeyword = ref<string>('');
const selectInput = ref<InstanceType<typeof VSelect> | null>(null);
const updateSelectedTagIds = ref<number[]>([]);
const isNoTagChecked = ref<boolean>(false);

const currentUrl = window.location.href;
const baseUrl = currentUrl.split('#')[0];
const newPath = '#/dashboard/company/tags';
const tagListUrl = `${baseUrl}${newPath}`;

const { tags, getCompanyTag } = useTagComposable();

const noTagChip: CustomTag = {
  id: NO_TAG_ID,
  name: String($t(sharedMessages.noTag)),
  color: 0,
};

const filteredTags = computed(() => {
  const searchedTags = defaultTags.value.filter((tag) =>
    tag.name.toLowerCase().includes(searchKeyword.value.toLowerCase())
  );
  return searchKeyword.value.length ? searchedTags : defaultTags.value;
});

const updateTags = (tag: Tag) => {
  if (selectedTags.value.some((selectedTag) => selectedTag.id === tag.id)) {
    selectedTags.value = selectedTags.value.filter(
      (selectTag) => selectTag.id !== tag.id
    );
    defaultTags.value = defaultTags.value.map((defaultTag) =>
      defaultTag.id === tag.id ? { ...defaultTag, selected: false } : defaultTag
    );
  } else {
    selectedTags.value = [...selectedTags.value, tag];
    defaultTags.value = defaultTags.value.map((defaultTag) =>
      defaultTag.id === tag.id ? { ...defaultTag, selected: true } : defaultTag
    );
  }
  emitTagChanges();
};

const emitTagChanges = () => {
  const tagIds = selectedTags.value.map((tag) => tag.id);

  updateSelectedTagIds.value = tagIds;
  props.isReturnTagObject
    ? emits('updateTags', selectedTags.value)
    : emits('updateTags', updateSelectedTagIds.value);
  emits('updateIncludeNoTag', isNoTagChecked.value);
};

const externalOperationSelectedTags = () => {
  isNoTagChecked.value = props.isNoTagSelected ?? false;

  const regularTagIds = props.selectedTagIds || [];

  selectedTags.value = tags.value.filter((tag) =>
    regularTagIds.includes(tag.id)
  );
  defaultTags.value = tags.value.map((tag) => ({
    ...tag,
    selected: regularTagIds.includes(tag.id),
  }));
};

watch(
  () => props.selectedTagIds,
  (tagIds) => {
    if (tagIds?.length) {
      externalOperationSelectedTags();
    } else {
      selectedTags.value = [];
      isNoTagChecked.value = props.isNoTagSelected ?? false;
      defaultTags.value = tags.value;
    }
  }
);

watch(
  () => props.isNoTagSelected,
  (value) => {
    isNoTagChecked.value = value ?? false;
  }
);

const toggleNoTag = () => {
  isNoTagChecked.value = !isNoTagChecked.value;
  emitTagChanges();
};

onMounted(async () => {
  await getCompanyTag();
  externalOperationSelectedTags();
  isLoading.value = false;
});

return { __sfc: true,$t, m, props, emits, isLoading, defaultTags, selectedTags, searchKeyword, selectInput, updateSelectedTagIds, isNoTagChecked, currentUrl, baseUrl, newPath, tagListUrl, tags, getCompanyTag, noTagChip, filteredTags, updateTags, emitTagChanges, externalOperationSelectedTags, toggleNoTag, TagChip, VSelect, sharedMessages, i18n }
}

})